// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tags_tagContainer__HrFCe","tagText":"Tags_tagText__Wkbgz","category":"Tags_category__pPk5u"};